import { Flex } from '@approvalmax/ui/src/components';
import styled from 'styled-components';

export const Root = styled(Flex)`
    margin-top: 8px;

    &:empty {
        margin-top: 0;
    }
`;
